import { WarningAmberRounded } from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

const DARK = "#0D1420";

interface ConfirmationDialogProps {
  open: boolean;
  title?: string;
  message: string;
  onClose: () => void;
  onConfirm: () => void;
  confirmText?: string;
  cancelText?: string;
  danger?: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  title = "Confirmar acción",
  message,
  onClose,
  onConfirm,
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  danger = true,
}) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    await onConfirm();
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 4, overflow: "hidden" } }}>
      {/* Header */}
      <Box sx={{ bgcolor: DARK, px: 3, py: 2.5, textAlign: "center" }}>
        <WarningAmberRounded sx={{ color: "#f59e0b", fontSize: 40, mb: 1 }} />
        <Typography sx={{ fontWeight: 800, fontSize: 18, color: "white" }}>{title}</Typography>
      </Box>

      <DialogContent sx={{ p: 3, textAlign: "center", bgcolor: "#f7f9f7" }}>
        <Typography sx={{ fontSize: 14, color: "#667788", lineHeight: 1.6 }}>{message}</Typography>
      </DialogContent>

      <Box sx={{ px: 2.5, py: 2, display: "flex", gap: 1.5, bgcolor: "white", borderTop: "1px solid #f0f0f0" }}>
        <Button
          fullWidth
          onClick={onClose}
          disabled={loading}
          sx={{ borderRadius: "50px", textTransform: "none", fontWeight: 600, border: "1px solid #e0e0e0", color: "#667788" }}
        >
          {cancelText}
        </Button>
        <Button
          fullWidth
          variant="contained"
          onClick={handleConfirm}
          disabled={loading}
          sx={{
            borderRadius: "50px",
            textTransform: "none",
            fontWeight: 700,
            bgcolor: danger ? "#ef4444" : "#00C853",
            color: "white",
            boxShadow: "none",
            "&:hover": { bgcolor: danger ? "#dc2626" : "#00b048" },
          }}
        >
          {loading ? <CircularProgress size={20} sx={{ color: "white" }} /> : confirmText}
        </Button>
      </Box>
    </Dialog>
  );
};

export default ConfirmationDialog;


